import cn from 'classnames'
import { Empty, Form, Select as SelectAntd, Spin } from 'antd'
import { ReactComponent as ChevronDown16 } from 'assets/svg/ChevronDown16.svg'
import { Props } from './types'
import './select.default.scss'
import { ReactComponent as Check16 } from '../../assets/svg/Check16.svg'
import { ReactElement, useMemo } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import {
  isSelectOptgroupEmptyValue,
  selectOptgroupEmptyValue
} from './optGroupEmpty'
import { Chips } from 'components/Chips/Chips'
import { ReactComponent as Information } from 'assets/svg/Information.svg'

const { OptGroup, Option } = SelectAntd

const Default = ({ ...props }: Props): ReactElement => {
  const onFilter = useMemo(() => {
    if (props.propsSelect?.filterOption !== undefined)
      return props.propsSelect.filterOption
    return (input, option) => {
      const value = option?.props?.value
      if (isSelectOptgroupEmptyValue(value)) {
        return !input
      }
      const childText =
        option?.props?.children?.props?.children ??
        option?.props?.children?.[0]?.props?.children

      return (
        String(childText ?? '')
          .toLowerCase()
          .indexOf(input?.toLowerCase()) >= 0 ||
        String(value ?? '')
          .toLowerCase()
          .indexOf(input?.toLowerCase()) >= 0
      )
    }
  }, [props.propsSelect])

  return (
    <Form.Item
      label={props?.label}
      className={cn('custom-select', 'select-default', props.className)}
      colon={false}
      {...props.propsItem}
      tooltip={
        props.propsItem?.tooltip
          ? {
              title: props.propsItem?.tooltip,
              icon: <Information />
            }
          : undefined
      }
      name={
        props.options.length || props.alwaysName ? props.propsItem?.name : ''
      }
    >
      <SelectAntd
        getPopupContainer={(node) => node}
        {...props.propsSelect}
        placement="bottomLeft"
        menuItemSelectedIcon={!props.onPagination && <Check16 />}
        notFoundContent={
          props.propsSelect?.loading ? (
            <div className="full-width flex justify-center mt-16 mb-16">
              <Spin size="large" indicator={<LoadingOutlined spin />} />
            </div>
          ) : undefined
        }
        dropdownClassName={cn(
          'custom-select__dropdown',
          props.dropdownClassName
        )}
        suffixIcon={<ChevronDown16 />}
        filterOption={onFilter}
        showSearch={
          props.propsSelect?.showSearch !== undefined
            ? props.propsSelect?.showSearch
            : true
        }
      >
        {props.options.map((option, groupIndex) =>
          !option?.options ? (
            <Option
              value={option.value}
              key={option.value}
              disabled={option.disabled}
            >
              <span className={option.className}>{option.label}</span>
              {option.chipsLabel && (
                <Chips closable={false} grey>
                  {option.chipsLabel}
                </Chips>
              )}
            </Option>
          ) : (
            <OptGroup
              label={option.label}
              key={option.key ?? `${String(option.label)}-${groupIndex}`}
            >
              {!!option.options.length ? (
                option.options.map((i) => (
                  <Option value={i.value} key={i.value} disabled={i.disabled}>
                    <span className={i.className}>{i.label}</span>
                    {i.chipsLabel && (
                      <Chips closable={false} grey>
                        {i.chipsLabel}
                      </Chips>
                    )}
                  </Option>
                ))
              ) : (
                <Option
                  disabled
                  value={selectOptgroupEmptyValue(groupIndex)}
                  key={selectOptgroupEmptyValue(groupIndex)}
                  className="custom-select__optgroup-empty-option"
                >
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No data"
                  />
                </Option>
              )}
            </OptGroup>
          )
        )}
      </SelectAntd>
    </Form.Item>
  )
}

export default Default
